import {
  Flexbox,
  FormField,
  Sentiments,
  Sizes,
  Text,
  TextInput,
} from '@sede-enterprise/shell-ds-react-framework';

export const roundValue = (value: string): string => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  return (+value).toFixed(2);
};

export const AvailabilityInputRow = (props: {
  testId?: string;
  maxExportPower: string | null;
  maxImportPower: string | null;
  energyCapacity: string | null;
  errors: {
    maxExportPower?: string;
    maxImportPower?: string;
    energyCapacity?: string;
    limits?: string;
  };
  touched: {
    maxExportPower?: boolean;
    maxImportPower?: boolean;
    energyCapacity?: boolean;
  };
  disabled?: boolean;
  onChange: (data: {
    maxExportPower: string | null;
    maxImportPower: string | null;
    energyCapacity: string | null;
  }) => void;
}) => {
  const handleChange = (
    value: string,
    parameter: 'import' | 'export' | 'energy',
  ) => {
    const roundedValue = roundValue(value);
    const valueToPush =
      roundedValue.length > value.length ? value : roundedValue;

    props.onChange({
      maxExportPower:
        parameter === 'export' ? valueToPush : props.maxExportPower,
      maxImportPower:
        parameter === 'import' ? valueToPush : props.maxImportPower,
      energyCapacity:
        parameter === 'energy' ? valueToPush : props.energyCapacity,
    });
  };

  return (
    <Flexbox flexDirection="column">
      <Flexbox flexDirection="row" columnGap="16px" style={{ width: '100%' }}>
        <FormField
          label="Export limit"
          mandatory={false}
          bottomLeftHelper={
            props.errors.maxExportPower && props.touched.maxExportPower
              ? {
                  content: props.errors.maxExportPower,
                  sentiment: Sentiments.Negative,
                }
              : undefined
          }
        >
          <TextInput
            disabled={props.disabled}
            data-testid={props.testId ? `${props.testId}-export` : undefined}
            size={Sizes.Medium}
            suffix={{ node: 'MW' }}
            type="number"
            min={0}
            value={props.maxExportPower ?? ''}
            onChange={(e) => {
              handleChange(e.target.value, 'export');
            }}
          />
        </FormField>

        <FormField
          label="Import limit"
          mandatory={false}
          bottomLeftHelper={
            props.errors.maxImportPower && props.touched.maxImportPower
              ? {
                  content: props.errors.maxImportPower,
                  sentiment: Sentiments.Negative,
                }
              : undefined
          }
        >
          <TextInput
            disabled={props.disabled}
            data-testid={props.testId ? `${props.testId}-import` : undefined}
            size={Sizes.Medium}
            suffix={{ node: 'MW' }}
            type="number"
            min={0}
            value={props.maxImportPower ?? ''}
            onChange={(e) => {
              handleChange(e.target.value, 'import');
            }}
          />
        </FormField>

        <FormField
          label="Energy limit"
          mandatory={false}
          bottomLeftHelper={
            props.errors.energyCapacity && props.touched.energyCapacity
              ? {
                  content: props.errors.energyCapacity,
                  sentiment: Sentiments.Negative,
                }
              : undefined
          }
        >
          <TextInput
            disabled={props.disabled}
            data-testid={props.testId ? `${props.testId}-energy` : undefined}
            size={Sizes.Medium}
            suffix={{ node: 'MWh' }}
            type="number"
            min={0}
            value={props.energyCapacity ?? ''}
            onChange={(e) => {
              handleChange(e.target.value, 'energy');
            }}
          />
        </FormField>
      </Flexbox>

      {props.errors.limits &&
        props.touched.maxExportPower &&
        props.touched.maxImportPower &&
        props.touched.energyCapacity && (
          <Text style={{ color: 'rgba(221, 29, 33, 1)' }} size={Sizes.Small}>
            {/* Shared message - at least one of export, import and energy required */}
            {props.errors.limits}
          </Text>
        )}
    </Flexbox>
  );
};
